mutation DocumentPoolDelete ($input: DocumentPoolDeleteInput!) {
  documentPoolDelete(input: $input) {
    deletedEntities {
      id
    }
  }
}

